import React from 'react';
import Slider from 'react-slick';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HeadingComponent from './headingComponent/HeadingComponent';
import 'react-lazy-load-image-component/src/effects/blur.css';

import img1 from '../assets/approved/1.png';
import img2 from '../assets/approved/7.png';
import img3 from '../assets/approved/3.jpg';
import img4 from '../assets/approved/4.png';
import img5 from '../assets/approved/5.gif';
import img6 from '../assets/approved/6.png';

const ApprovedBy = () => {
	const settings = {
		infinite: true,
		speed: 1000,
		autoplay: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		initialSlide: 0,
		navs: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					// dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	const images = [img1, img2, img3, img4, img5, img6];

	return (
		<div className='container-fluid'>
			<HeadingComponent
				headerName={'Bihar’s Leading Rooftop Solar Startup Approved by'}
			/>
			<div className='container'>
				<Slider {...settings}>
					{images.map((img, index) => (
						<div key={index} className='slideWrapper__approvedBy'>
							<LazyLoadImage
								src={img}
								alt='approvedby_images'
								// style={index === 3 ? { padding: '1rem' } : {}}
							/>
						</div>
					))}
				</Slider>
			</div>
		</div>
	);
};

export default ApprovedBy;
